import React from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

const SidebarContent = ({
  onClick,
  changeToDark,
  changeToLight,
  sidebarCollapse,
}) => (
  <div className="sidebar__content">
    <ul className="sidebar__block">
      <SidebarCategory title="Research & Email Craft" icon="book" sidebarCollapse={sidebarCollapse}>
        <SidebarLink title="Account" route="/research/account/single" onClick={onClick} openInNewTab />
        <SidebarLink title="Contact" route="/research/contact/single" onClick={onClick} openInNewTab />
      </SidebarCategory>
      <SidebarCategory title="Find" icon="layers" sidebarCollapse={sidebarCollapse}>
        <SidebarLink title="Lookalike" route="/find/lookalike" onClick={onClick} openInNewTab />
        <SidebarLink title="Tech Stack" route="/find/tech-stack" onClick={onClick} openInNewTab />
      </SidebarCategory>
    </ul>
    {/* <ul className="sidebar__block">
      <SidebarLink title="Revenue Attribution" route="/pages/one" onClick={onClick} />
      <SidebarLink title="Integrations" route="/pages/two" onClick={onClick} />
      <SidebarCategory title="Example Pages" icon="diamond" sidebarCollapse={sidebarCollapse}>  
        <SidebarCategory title="Example Subpages" sidebarCollapse={sidebarCollapse}>
          <SidebarLink title="Subpage one" route="/" onClick={onClick} />
          <SidebarLink title="Subpage two" route="/" onClick={onClick} />
        </SidebarCategory>
        <button type="button" className="sidebar__link" onClick={changeToLight}>
          <p className="sidebar__link-title">Light Theme</p>
        </button>
        <button type="button" className="sidebar__link" onClick={changeToDark}>
          <p className="sidebar__link-title">Dark Theme</p>
        </button>
      </SidebarCategory>
    </ul> */}
  </div>
);

SidebarContent.propTypes = {
  changeToDark: PropTypes.func.isRequired,
  changeToLight: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  sidebarCollapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  sidebarCollapse: false,
};

export default SidebarContent;
